import { LayerSpecification } from 'maplibre-gl';
import { env } from 'next-runtime-env';

import type { MapStyle } from '@/features/mapbox/provider/useMapboxBaseMapState';

import resolveV2 from '../resolverV2';
import DataResponse from '../types';

// This is what we need from the response
type MapStyleResponse = {
  layers: LayerSpecification[];
  id: string;
  sources: Record<string, any>;
};

export async function getMapStyle(
  selectedMapStyle: MapStyle
): Promise<MapStyleResponse> {
  const token = env('NEXT_PUBLIC_MAPTILER_TOKEN');

  const data: DataResponse<any> = await resolveV2(
    {
      url: `https://api.maptiler.com/maps/${selectedMapStyle}/style.json?key=${token}`,
    },
    {
      withCredentials: false,
    }
  );

  return data?.res?.data;
}
